import React, { useEffect, useRef } from 'react';

const useDidMountEffect = (reflected: (...p: any) => any, dependencies: any[]) => {
	const didMount = useRef(false);

	useEffect(() => {
		if (didMount.current) reflected();
		else didMount.current = true;
	}, dependencies);
};

export default useDidMountEffect;
